import { Drawer, styled, Theme } from '@mui/material';
import { CSSObject } from '@mui/material/styles';
import Colors from '../../entities/colors';

export const DEFAULT_DRAWER_WIDTH = '12%';
export const LG_DRAWER_WIDTH = '15%';
export const MD_DRAWER_WIDTH = '20%';
export const SM_DRAWER_WIDTH = '30%';

export const MINI_VARIANT_WIDTH = '56px';

const openedMixin = (theme: Theme): CSSObject => ({
  background: Colors.N300,
  width: DEFAULT_DRAWER_WIDTH,
  [theme.breakpoints.down('xl')]: {
    width: `${LG_DRAWER_WIDTH} !important`,
  },
  [theme.breakpoints.down('lg')]: {
    width: MD_DRAWER_WIDTH,
  },
  [theme.breakpoints.down('md')]: {
    width: SM_DRAWER_WIDTH,
  },
  border: 'none',
  transition: [
    theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  ],
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  background: Colors.N300,
  border: 'none',
  transition: [
    theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  ],
  overflowX: 'hidden',
  width: MINI_VARIANT_WIDTH,
});

const StyledDrawer = styled(Drawer)(({ open, theme }) => ({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
  background: Colors.N300,
}));

export default StyledDrawer;
